import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn } from "../Styles/InputStyles";

const DeleteDocument = ({
    setShowDeleteDocument,
    selectedData,
    isDeleteLoading,
    deleteMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteMutate();
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setShowDeleteDocument}
            title="Confirm Deletion"
        >
            <WarningText>
            Are you sure you want to delete this{" "}
            {selectedData?.type === "folder" ? "folder" : "file"}{" "}
                ‘{selectedData?.name || selectedData?.title}’
            ?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={isDeleteLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {isDeleteLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteDocument;